export const WIS_DOMAIN = 'wildixintegration.eu';
export const WIS_RESPONSE_RECEIVED = 'wis/RESPONSE_RECEIVED';
export const WIS_MESSAGE_TYPE = Object.freeze({
    UNKNOWN: 'unknown',
    EVENT: 'event',
    RESPONSE: 'response'
});
export const WIS_MESSAGE_APP = Object.freeze({
    UNKNOWN: 'unknown',
    WISERVICE: 'wiservice',
    HEADSET: 'headset',
    SCREEN_CONTROL: 'screenControl'
});
export const WIS_RPC_MESSAGE = Object.freeze({
    WISERVICE: 'M_WISERVICE',
    HEADSET: 'M_HEADSET'
});
export const WIS_RPC_COMMANDS = Object.freeze({
    AUTHORIZE: 'authorize',
    VERSION: 'version',
    GET_VERSION: 'getversion',
    GET_STATUS: 'getstatus',
    READY: 'ready',
    SET_PRESENCE: 'setpresence',
    TALKING: 'talking',
    TERMINATE: 'terminate',
    MUTE: 'mute',
    UNMUTE: 'unmute'
});
export const WIS_EVENTS = Object.freeze({
    CONNECT: 'connect',
    RECONNECT: 'reconnect',
    MUTE: 'mute',
    UNMUTE: 'unmute',
    HANGUP: 'hangup'
});
export const WIS_PRESENCE = Object.freeze({
    REGISTERED: 'registered',
    AVAILABLE: 'available',
    TALKING: 'talking',
    DND: 'dnd'
});
